import axios from 'axios'
import QS from 'qs'
import { Form, message } from 'ant-design-vue'
import Router from '@/router/index'

// axios.defaults.baseURL = "/api"
axios.defaults.baseURL = "https://hxr.yefangan.com"
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.post.accept = '*/*'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.post['Access-Control-Allow-Credentials'] = true


// 请求拦截器
axios.interceptors.request.use(request => {
    return request
})

// 响应拦截器
axios.interceptors.response.use(response => {
    return response

})

export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: params })
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post( url, JSON.stringify(params),
            {headers:{
                    "Content-Type":'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Credentials': true,
                }}
            )
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export function put(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, JSON.stringify(params),
            {headers:{
                    "Content-Type":'application/json',
                    'Access-Control-Allow-Origin': url,
                    'Access-Control-Allow-Credentials': true,
                }})
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export function del(url) {
    return new Promise((resolve, reject) => {
        axios.delete(url,
            {headers:{
                    'Access-Control-Allow-Origin': "*",
                    'Access-Control-Allow-Credentials': true,
                }})
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}
